export function formatDateFromISO(isoDate: string): string {
  const date = new Date(isoDate);
  console.log(date);
  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
  };
  const formattedDate: string = date.toLocaleDateString(undefined, options);
  return formattedDate;
}

export function formatDateAndTimeFromISO(isoDate: string): string {
  const date = new Date(isoDate);
  const formattedDate = `${("0" + (date.getMonth() + 1)).slice(-2)}-${(
    "0" + date.getDate()
  ).slice(-2)}-${date.getFullYear()}, ${("0" + date.getHours()).slice(-2)}:${(
    "0" + date.getMinutes()
  ).slice(-2)}`;
  return formattedDate;
}
